import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { setCartOpen } from '../store/cartSlice'
import CartItems from './CartItems.jsx'
import CartBottom from './CartBottom.jsx'
import CartReferral from './CartReferral.jsx'

const CartDrawer = (data) => {
  const dispatch = useDispatch()
  const { cart, open } = useSelector((state) => state.cart)

  const drawer = document.querySelector('[data-cart-drawer]')
  drawer.classList.toggle('z-[-1]', !open)
  drawer.classList.toggle('opacity-0', !open)
  drawer.classList.toggle('z-50', open)
  drawer.classList.toggle('opacity-100', open)
  document.body.classList.toggle('overflow-hidden', open)

  return (
    <div
      className={`h-full absolute w-full lg:w-[30.5rem] bg-white transition duration-300 ease-in-out px-3 lg:px-10 pt-6 pb-10 ${open ? 'right-0' : 'right-[-31rem]'}`}
    >
      <div className="flex items-center justify-between">
        <span className="">
          {window.cartStrings.cart}&nbsp;&nbsp;
          <sup className="text-[0.875rem]">{cart.item_count}</sup>
        </span>
        <button
          className="w-5 h-5"
          data-cart-close
          aria-label="Close the cart"
          onClick={(e) => dispatch(setCartOpen(false))}
          dangerouslySetInnerHTML={{ __html: window.globalIcons['icon-close'] }}
        />
      </div>
      <div className="h-[calc(100%-1.5rem)] pt-10 flex flex-col justify-between overflow-auto">
        {cart.item_count == 0 && (
          <div className="mt-10 text-center w-full">
            {window.cartStrings.empty}
            <a className="mt-6 button button--primary w-full" href={data.data.cartCollectionUrl}>
              {window.cartStrings.shopNow}
            </a>
          </div>
        )}

        {cart.item_count > 0 && (
          <div className="h-full overflow-auto">
            <CartItems />
          </div>
        )}

        {cart.item_count > 0 && <CartReferral />}

        {cart.item_count > 0 && <CartBottom />}
      </div>
    </div>
  )
}

export default CartDrawer
